import React from 'react';

import MessageItem from './MessageItem';
import ActivityLogItem from './ActivityLogItem';


const MessageList = ({
  authUser,
  messages,
  onEditMessage,
  onRemoveMessage,
}) => (
  <article>
    {messages.map(message => {
      // Render activity logs differently from regular messages
      if (message.isActivityLog) {
        return (
          <ActivityLogItem
            key={message.id || message.uid}
            log={message}
          />
        );
      }
      
      return (
        <MessageItem
          authUser={authUser}
          key={message.uid}
          message={message}
          onEditMessage={onEditMessage}
          onRemoveMessage={onRemoveMessage}
        />
      );
    })}
  </article>
);

export default MessageList;
